import { makeAutoObservable, onBecomeObserved } from "mobx"

import { catchErrors, merchantApi, projectsApi } from "@src/shared/api"
import { ReportCreate, ReportCreateTypeEnum } from "@src/shared/api/generated"
import { notify } from "../notify"

export class ReportsStore {
  private _projects?: any[]

  addDate = (from: string, to: string) => {
    this.form = { ...this.form, from, to }
  }

  addProject = (project_id?: string) => {
    this.form = { ...this.form, project_id }
  }

  form: any = {
    from: "",
    project_id: undefined,
    to: "",
  }

  isLoading = false

  loadProjects = async () => {
    try {
      this.isLoading = true

      const { data: result } = await projectsApi.getProjects(undefined, 0, 100)

      if (result.success) {
        this._projects = result.data?.data as any[]
      }
    } catch (error: any) {
      catchErrors(error)
    } finally {
      this.isLoading = false
    }
  }

  sendReportRequest = async (type: ReportCreateTypeEnum) => {
    try {
      this.isLoading = true
      const reportPayload: ReportCreate =
        type === ReportCreateTypeEnum.Balance
          ? { type }
          : {
              date_from: this.form.from,
              date_to: this.form.to,
              project_id: this.form.project_id,
              type,
            }

      const { data: result } = (await merchantApi.createReport(
        reportPayload,
      )) as any

      if (result.success) {
        notify.success(result.message)
      }
    } catch (error: any) {
      catchErrors(error)
    } finally {
      this.isLoading = false
    }
  }

  constructor() {
    makeAutoObservable(this)

    onBecomeObserved(this, "_projects", this.loadProjects)
  }

  get projects() {
    return (
      this._projects?.map((item) => ({ label: item.name, value: item.id })) ||
      []
    )
  }
}
